export interface SortOptions { mode: "alpha" | "length" | "shuffle" | "none"; reverse: boolean; ignoreCase: boolean; natural: boolean; trim: boolean; removeBlank: boolean; removeDupes: boolean }

export interface SortResult { text: string; before: number; after: number }

/** Sorts / cleans a list of lines. Duplicates are found after trimming and (when "ignore case" is on) lower-casing,
 * keeping the first occurrence; with mode "none" the original order is kept (just clean-up). */
export function sortText(input: string, o: SortOptions, random: () => number = Math.random): SortResult {
  let lines = input.replace(/\r\n?/g, "\n").split("\n");
  if (lines.length && lines[lines.length - 1] === "") lines.pop();
  const before = lines.length;
  if (o.trim) lines = lines.map((l) => l.trim());
  if (o.removeBlank) lines = lines.filter((l) => l.trim() !== "");
  if (o.removeDupes) {
    const seen = new Set<string>();
    lines = lines.filter((l) => {
      const key = (o.trim ? l : l.trim()).normalize("NFC");
      const k = o.ignoreCase ? key.toLocaleLowerCase() : key;
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  }
  const collator = new Intl.Collator(undefined, { numeric: o.natural, sensitivity: o.ignoreCase ? "base" : "variant", caseFirst: "upper" });
  if (o.mode === "alpha") lines.sort((a, b) => collator.compare(a, b));
  else if (o.mode === "length") lines.sort((a, b) => a.length - b.length || collator.compare(a, b));
  else if (o.mode === "shuffle") for (let i = lines.length - 1; i > 0; i--) { const j = Math.floor(random() * (i + 1)); [lines[i], lines[j]] = [lines[j], lines[i]]; }
  if (o.reverse && o.mode !== "shuffle") lines.reverse();
  return { text: lines.join("\n"), before, after: lines.length };
}
